import { useQuery, UseQueryOptions } from 'react-query';
import client from 'client';

export interface TicketRule {
    dayIds?: number[];
    eventId: number;
    limited: boolean;
    max: number;
    min: number;
    selectBy: string;
    ticketIds: number[];
    sessionIds?: number[];
    trackIds?: number[];
}

export type SessionRegistrationSettingsByTicket = {
    overlappingSessions: number[];
    sessions: number[];
    ticketRule: TicketRule;
};

const fetchSessionRegistrationSettingsByTicket = async (eventId?: number, ticketId?: number) => {
    if (!ticketId || !eventId) {
        return { sessions: [], overlappingSessions: [], ticketRule: {} };
    }

    const response = await client().get<SessionRegistrationSettingsByTicket>(
        `/api/v2/agenda/events/${eventId}/sessionRegistrationSettingsByTicketId?ticketId=${ticketId}&platform=web
        `
    );
    const { sessions = [], overlappingSessions = [], ticketRule = {} } = response.data;
    return { sessions, overlappingSessions, ticketRule };
};

const useSessionRegistrationSettingsByTicket = <TData = SessionRegistrationSettingsByTicket>(
    eventId: number,
    ticketId: number,
    options?: UseQueryOptions<SessionRegistrationSettingsByTicket, Error, TData>
) => {
    return useQuery(
        'session_registration_settings_by_ticket',
        () => fetchSessionRegistrationSettingsByTicket(eventId, ticketId),
        options
    );
};

export default useSessionRegistrationSettingsByTicket;
